<template>
  <div class="model">
    <div class="tip-model">
      <span v-show="iconShow"><svg class="icon"  aria-hidden="true"><use xlink:href="#icon-tishi-1"></use></svg></span>
      <slot></slot>
      <div class="flex-between buttons">
        <el-button class="tip-cancel-btn" @click="handleClose" v-show="cancelButton">{{ cancelText }}</el-button>
        <el-button class="form-btn" @click="handleSure" v-show="confirmButton">{{ confirmText }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tipModel",
  props: {
    cancelButton: {
      type: Boolean,
      default: false
    },
    confirmButton: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: ''
    },
      iconShow:{
        type:Boolean,
        default:true
      },
    cancelText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    handleSure() {
      this.$emit('sureTip')
    },
    handleClose() {
      this.$emit('closeTip')
    }
  }

}
</script>
<style lang="scss">
[dir='ltr'] .tip-model{
  .el-button+.el-button{
    margin-left: 10px;
  }
}
[dir='rtl'] .tip-model{
  .el-button+.el-button{
    margin-left: 0 !important;
    margin-right: 10px;
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
.tip-model {
  border-radius: 6px;
  padding: 32px;
  @include background_color('dialog-bg');
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05);
  text-align: center;
  width: 540px;
  max-width: 540px;
  position: relative;

  .icon {
    width: 48px;
    height: 48px;
  }

  .tip-cancel-btn {
    font-size: $font-size-small;
    height: 40px;
    line-height: 1;
    padding: 0;
    border: none;
    @include font_color('font-color-1');
    @include background_color('button-bg-normal');
    width: 100%;
  }

  .form-btn {
    padding: 0;
    font-size: $font-size-small;
    height: 40px;
    line-height: 1;
  }

  .buttons {
    margin-top: 16px;
    .form-btn {
      width: 100%;
    }
  }
}
</style>
